import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const ITestProfileService = ( createDecorator('testProfileService'));
export { ITestProfileService };
